var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { Tooltip } from "../../../Tooltip";
import { Icon } from "../../../Icon";
// styles
import "./sidebarItem.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-sidebarItem",
};
const SidebarItem = (_a) => {
    var { onClick, iconName, label, isOpen, position, parentRef, className } = _a, rest = __rest(_a, ["onClick", "iconName", "label", "isOpen", "position", "parentRef", "className"]);
    const classList = classNames("tecma-sidebarItem", className);
    const tooltipPosition = {
        right: "left",
        left: "right",
        top: "bottom",
        bottom: "top",
    };
    return (_jsx(Tooltip, Object.assign({ disableFocusListener: true, placement: position ? tooltipPosition[position] : "right", title: label }, rest, { children: _jsxs("li", { onClick: onClick, role: "presentation", className: classList, children: [iconName && _jsx(Icon, { iconName: iconName }), isOpen && _jsx("span", { children: label })] }) })));
};
SidebarItem.defaultProps = defaultProps;
export default React.memo(SidebarItem);
